"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorVariableInputField = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var ROITextInput_1 = require("./ROITextInput");
var ROICalculatorVariableInputField = (function (_super) {
    __extends(ROICalculatorVariableInputField, _super);
    function ROICalculatorVariableInputField() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.internalValue = null;
        _this.handleValueChange = function (inputName, newValue) {
            var _a = _this.props, min = _a.min, max = _a.max;
            _this.internalValue = newValue;
            if (newValue === "") {
                _this.props.onChange(inputName, "0");
                return;
            }
            var parsedValue = parseFloat(newValue);
            if (parsedValue <= max && parsedValue >= min) {
                _this.props.onChange(inputName, newValue);
            }
        };
        _this.handleBlur = function () {
            _this.internalValue = null;
        };
        return _this;
    }
    ROICalculatorVariableInputField.prototype.render = function () {
        var _a;
        var _b = this.props, label = _b.label, prefix = _b.prefix, suffix = _b.suffix, onValueEdited = _b.onValueEdited;
        return (react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "value", type: "number", label: label, startElement: prefix, endElement: suffix, onChange: this.handleValueChange, value: (_a = this.internalValue) !== null && _a !== void 0 ? _a : this.props.value, error: this.errorMessage, onValueEdited: onValueEdited, onBlur: this.handleBlur }));
    };
    Object.defineProperty(ROICalculatorVariableInputField.prototype, "errorMessage", {
        get: function () {
            var _a;
            var _b = this.props, min = _b.min, max = _b.max;
            var value = (_a = this.internalValue) !== null && _a !== void 0 ? _a : this.props.value;
            var parsedValue = parseFloat(value);
            if (parsedValue > max || parsedValue < min) {
                return "".concat(parsedValue, " is not in the range ").concat(min, "-").concat(max);
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROICalculatorVariableInputField.prototype, "internalValue", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorVariableInputField.prototype, "errorMessage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorVariableInputField.prototype, "handleValueChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorVariableInputField.prototype, "handleBlur", void 0);
    ROICalculatorVariableInputField = __decorate([
        mobx_react_1.observer
    ], ROICalculatorVariableInputField);
    return ROICalculatorVariableInputField;
}(react_1.default.Component));
exports.ROICalculatorVariableInputField = ROICalculatorVariableInputField;
